import React from 'react';

const Footer = () => {
  const footerLinks = [
    { name: 'About Us', href: '#' },
    { name: 'Contact Us', href: '#' },
    { name: 'Privacy Policy', href: '#' },
    { name: 'Disclaimer', href: '#' },
  ];

  return (
    <footer className="bg-gradient-to-br from-gray-950 to-black text-white py-8 md:py-12 px-4 border-t border-gray-800">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col items-center">
          <div className="flex flex-wrap justify-center gap-6 md:gap-8 mb-6">
            {footerLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-gray-400 hover:text-blue-400 transition-colors duration-300 text-sm md:text-base font-medium hover:underline underline-offset-4"
              >
                {link.name}
              </a>
            ))}
          </div>
          <div className="border-t border-gray-800 w-full max-w-md mb-6"></div>
          <p className="text-gray-500 text-sm md:text-base text-center">
            © 2026 jalwagameszone
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
